<template>
  <div class="mb-4">
    <div class="d-flex justify-space-between align-center">
      <h3 class="font-weight-bold mb-2">
        {{ tituloReporte }} AL: {{ fechaReporte }}
      </h3>
      <div class="d-flex">
        <!-- Botón Excel con loading localizado -->
        <div class="excel-btn-container mr-2" style="position: relative;">
          <v-btn
            color="teal"
            small
            @click="$emit('export-excel')"
            :disabled="!hasData || isExportingExcel"
            :loading="isExportingExcel"
          >
            <v-icon left small>mdi-microsoft-excel</v-icon>
            Exportar Excel
          </v-btn>

          <!-- Overlay de loading para segundo plano Excel -->
          <div v-if="isExportingInBackground" class="loading-overlay loading-overlay-excel">
            <v-progress-circular
              indeterminate
              color="white"
              size="20"
              width="2"
            ></v-progress-circular>
          </div>
        </div>

        <!-- Botón PDF con loading localizado -->
        <div class="pdf-btn-container" style="position: relative;">
          <v-btn
            color="deep-orange"
            small
            @click="$emit('export-pdf')"
            :disabled="!hasData || isExporting"
            :loading="isExporting"
          >
            <v-icon left small>mdi-file-pdf-box</v-icon>
            Exportar PDF
          </v-btn>

          <!-- Overlay de loading para segundo plano PDF -->
          <div v-if="isExportingPdfInBackground" class="loading-overlay loading-overlay-pdf">
            <v-progress-circular
              indeterminate
              color="white"
              size="20"
              width="2"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportHeader',
  props: {
    tituloReporte: {
      type: String,
      default: 'INFORME DE SOLICITUDES',
    },
    fechaReporte: {
      type: String,
      required: true,
    },
    hasData: {
      type: Boolean,
      default: false,
    },
    isExporting: {
      type: Boolean,
      default: false,
    },
    isExportingExcel: {
      type: Boolean,
      default: false,
    },
    isExportingInBackground: {
      type: Boolean,
      default: false,
    },
    isExportingPdfInBackground: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['export-excel', 'export-pdf'],
};
</script>

<style scoped>
h3 {
  font-size: 18px;
  color: #1e1e1e;
}

.excel-btn-container,
.pdf-btn-container {
  position: relative;
  display: inline-block;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  z-index: 1;
  pointer-events: none;
}

.loading-overlay-excel {
  background-color: rgba(0, 150, 136, 0.85);
}

.loading-overlay-pdf {
  background-color: rgba(255, 87, 34, 0.85);
}
</style>